import { useEffect, useState } from 'react';
import styles from './MidtermGoftinoButton.module.scss';
import Icon from '@/components/UI/icon/Icon';
import TooltipGoftino from './tooltipGoftino/TooltipGoftino';
import Box from '@/components/UI/box/Box';
interface MidtermGoftinoButton {
  showDownloadBanner: boolean;
  onToggle: () => void;
}
const MidtermGoftinoButton = ({
  showDownloadBanner,
  onToggle
}: MidtermGoftinoButton) => {
  const [isDownloadBanner, setIsDownloadBanner] = useState(false);
  useEffect(() => {
    if (sessionStorage.getItem('show-download-banner')) {
      setIsDownloadBanner(false);
    } else {
      setIsDownloadBanner(true);
    }
  }, [showDownloadBanner]);
  return <>
      <Box className={`${styles['button']} ${isDownloadBanner ? styles['has-banner'] : ''}`} onClick={onToggle} data-sentry-element="Box" data-sentry-source-file="MidtermGoftinoButton.tsx">
        <Icon size={'xLarge'} name={'message'} type={'white'} data-sentry-element="Icon" data-sentry-source-file="MidtermGoftinoButton.tsx" />
        <TooltipGoftino text="مشاوره رایگان" data-sentry-element="TooltipGoftino" data-sentry-source-file="MidtermGoftinoButton.tsx" />
      </Box>
    </>;
};
export default MidtermGoftinoButton;